import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { QueryKey } from '@/Config/api/queryKey';
import { RecentAssistedOrdersResponseDto } from '@/Domain/api/AssistedOrders/AssistedOrders.dto';
import { DateRangeState } from '@/Domain/types/DateRange.types';

export const RECENT_ORDERS_PAGE_SIZE = 10;

const toISODate = (date: Date) => format(date, 'yyyy-MM-dd');

export const useRecentAssistedOrders = (range: DateRangeState) => {
  const startDate = toISODate(range.startDate);
  const endDate = toISODate(range.endDate);
  const [pageIndex, setPageIndex] = useState(0);

  // A narrower range can leave us past the last page — snap back to the first.
  useEffect(() => setPageIndex(0), [startDate, endDate]);

  const query = useQuery<RecentAssistedOrdersResponseDto>({
    queryKey: [
      QueryKey.assistedOrders.recent,
      {
        start_date: startDate,
        end_date: endDate,
        limit: RECENT_ORDERS_PAGE_SIZE,
        offset: pageIndex * RECENT_ORDERS_PAGE_SIZE,
      },
    ],
    placeholderData: keepPreviousData,
  });

  return { ...query, pageIndex, setPageIndex };
};
